import { render } from "./ValidationErrorMsgList.vue?vue&type=template&id=23f0df86"
import script from "./ValidationErrorMsgList.vue?vue&type=script&lang=js"
export * from "./ValidationErrorMsgList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__